/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */

import { publicConstants } from '../constants';

import type { NodeProps } from './types';

class WhenNode {
  readonly type: string;
  readonly subType: string;
  readonly name: string;
  readonly referenceName: string;
  public props: NodeProps;

  constructor(subType: string, referenceName: string, name: string, options: NodeProps = {}) {
    this.type = publicConstants.CONTEXT_TREE_NODE_TYPES.WHEN;
    this.subType = subType;
    this.referenceName = referenceName;
    this.name = name;
    this.props = options;
  }
}
export default WhenNode;
